import { ResultSet } from "@cubejs-client/core";

import { AppThunk } from "appThunk";
import { Store } from "modules/customer/insights/portfolioNew/store";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";

export class RetailCentreFootfall {
    public readonly storeID: string;
    public readonly currentYearFootfall: number;
    public readonly previousYearFootfall: number;

    constructor(
        storeID: string,
        currentYearFootfall: number,
        previousYearFootfall: number,
    ) {
        this.storeID = storeID;
        this.currentYearFootfall = currentYearFootfall;
        this.previousYearFootfall = previousYearFootfall;
    }
}

export const loadRetailCentreFootfall = (stores: Store[]): AppThunk<Promise<RetailCentreFootfall[]>> => async (dispatch) => {
    try {
        const retailCentreIDs = stores.map(store => store.retailCentreID.toString());
        const query = {
            dimensions: [
                "RetailCentreYearlyFootfall.RetailCentreID",
                "RetailCentreYearlyFootfall.Prev12MonthsFootfall",
                "RetailCentreYearlyFootfall.TwelveMonthsPriorToPrev12MonthsFootfall",
            ],
            filters: [{
                member: "RetailCentreYearlyFootfall.RetailCentreID",
                operator: "equals",
                values: retailCentreIDs
            }]
        };
        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        const rawData = resultSet.rawData();
        return stores.map(store => {
            const row = rawData.find(row => row["RetailCentreYearlyFootfall.RetailCentreID"] === store.retailCentreID);

            return new RetailCentreFootfall(
                store.id,
                row ? Number(row["RetailCentreYearlyFootfall.Prev12MonthsFootfall"]) : 0,
                row ? Number(row["RetailCentreYearlyFootfall.TwelveMonthsPriorToPrev12MonthsFootfall"]) : 0
            );
        });
    } catch (error) {
        dispatch(logError("Error loading RetailCentreFootfall.", error));
        throw error;
    }
};
